import heroSlider from './hero-slider';
import tabbedSection from './tabbed-section';
import resourceFeed from './resource-feed';
import blogFeed from './blog-feed';
import blogFeaturedSeries from './blog-featured-series';
import awardFeed from './award-feed';
import pressReleaseFeed from './press-release-feed';
import newsMentionFeed from './news-mention-feed';
import assetFeed from './asset-feed';
import taxonomyFeed from './taxonomy-feed';
import eventWebinarFeed from './event-webinar-feed';
import gpiReviewSlider from './gpi-review-slider';

export default {
    init() {
        heroSlider.init();
        tabbedSection.init();
        resourceFeed.init();
        blogFeed.init();
        blogFeaturedSeries.init();
        awardFeed.init();
        pressReleaseFeed.init();
        newsMentionFeed.init();
        assetFeed.init();
        taxonomyFeed.init();
        eventWebinarFeed.init();
        gpiReviewSlider.init();
    },
};
